import {Routes} from '@angular/router';
import {ReferentDetailComponent} from './referent-detail.component';


export const referentRoute: Routes = [
  {
    path: 'recommandation',
    component: ReferentDetailComponent,
    data: {
        authorities: [],
        pageTitle: 'cadensApp.referent.home.title'
    }
  }
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/referent/referent.route.ts